import React, { useState } from "react";
import { IoFilterOutline } from "react-icons/io5";
import SidebarItem from "./SidebarItem";
import { IoCloseOutline } from "react-icons/io5";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import {
  Card,
  SideBarActiveDiv,
  SideBarActiveDivButton,
  SideBarNormalDiv,
  SideBarActiveDivButtonNew,
  SideBarNormalDivNew,
  SideBarActiveDivNew,
  SideBarNormalDivButtonNew,
  SideBarNormalCount,
  SideBarActiveCount,
} from "../../pages/Theme";
import { useHistory, useLocation } from "react-router-dom";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import SidebarItemNew from "./SidebarItemNew";

function Sidebar({
  data,
  selectedOption,
  setSelectedOption,
  announceList,
  isAnnounce,
  groupId,
  isVideoGroup,
  videosList,
  isJournal,
  isShared,
  isShowcaseGallery,
  valueId,
  isFeed,
  groupedFilterData,
  grouepdValuedata,
}) {
  const history = useHistory();
  const location = useLocation();

  const [show, setShow] = useState(false);

  const [sidebar, setSidebar] = useState(data.open);
  const [isAnnounceSidebar, setisAnnounceSidebar] = useState(true);
  const showSidebar = () => setSidebar(!sidebar);

  const Tab = ({ text, active, ...props }) => {
    let style = "font-14px font-medium cursor-pointer hover:text-blue-500";
    return active ? (
      <SideBarActiveDiv className={style}>{text}</SideBarActiveDiv>
    ) : (
      <SideBarNormalDiv className={style}>{text}</SideBarNormalDiv>
    );
  };
  return (
    <div className="lg:w-64 md:top-32 flex flex-row lg:flex-col-reverse">
      <div className="lg:hidden border-bottom-f1 flex items-center">
        <div className="bg-white flex items-center h-12 pl-10 pr-4 mr-4 ">
          <IoFilterOutline
            className="w-6 h-6 cursor-pointer"
            onClick={() => setShow(true)}
          />
        </div>
      </div>
      <Card
        className={
          show
            ? `inline-block lg:bg-white lg:bg-opacity-100 
                                 lg:mt-0 bg-black bg-opacity-60 w-full h-[calc(100vh-88px)]  
                                overflow-auto lg:pr-20 fixed topbar-offset lg:relative z-10 pr-16`
            : `hidden lg:inline-block lg:bg-white lg:bg-opacity-100 
                                mt-20 lg:mt-0 
                                overflow-hidden fixed top-0 lg:relative z-10 border20px pb-4`
        }
      >
        {/* Nithish added */}
        {isVideoGroup == true && (
          <>
            <div className="pb-3 pt-3 p-4">
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={showSidebar}
              >
                <Tab text="Topics" active={true} />
                <div className="">
                  {sidebar ? (
                    <MdKeyboardArrowRight className="blueColor" size={20} />
                  ) : (
                    <MdKeyboardArrowDown className="blueColor" size={20} />
                  )}
                </div>
              </div>
              <div className="flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2">
                {!sidebar &&
                  Object.entries(videosList)?.map((key, index) => {
                    return key?.map((keys, ind) => {
                      if (typeof keys === "string") {
                        return selectedOption === keys ? (
                          <>
                            {" "}
                            <SideBarActiveDivButtonNew
                              type="button"
                              className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                              key={index}
                              value={keys}
                              onClick={(e) => setSelectedOption(keys)}
                            >
                              <span className="flex-1 mr-1 break-anywhere">
                                {keys}
                              </span>
                              <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-5 h-5">
                                {key[1]?.length || 0}
                              </SideBarActiveCount>
                            </SideBarActiveDivButtonNew>
                          </>
                        ) : (
                          <>
                            {" "}
                            <SideBarNormalDivButtonNew
                              type="button"
                              className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                              key={index}
                              value={keys}
                              onClick={(e) => setSelectedOption(keys)}
                            >
                              <span className="flex-1 mr-1 break-anywhere">
                                {keys}
                              </span>
                              <SideBarNormalCount className="inline-flex flex-shrink-0 items-center justify-center p-1 text-center text-xs w-5 h-5">
                                {key[1]?.length || 0}
                              </SideBarNormalCount>
                            </SideBarNormalDivButtonNew>
                          </>
                        );
                      }
                    });
                  })}
              </div>
            </div>
          </>
        )}
        {/* ShowcaseGallery */}
        {isShowcaseGallery == true && (
          <>
            <div className="w-full px-4">
              {data.map((items, index) => {
                const filteredItemsObject = {
                  ...items, // keep all existing properties
                  item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                };
                return (
                  <SidebarItemNew
                    key={index}
                    items={filteredItemsObject}
                    selectedOption={selectedOption}
                    setSelectedOption={(selectedValue) =>
                      setSelectedOption(index + 1, selectedValue)
                    }
                    isShowcaseGallery={isShowcaseGallery}
                  />
                );
              })}
              <div
                className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                onClick={() => setShow(false)}
              >
                <IoCloseOutline className="w-8 h-8" />
              </div>
            </div>
          </>
        )}
        {/* ---------------------------------------------------------------------------------------------------------------- */}
        {!isShowcaseGallery && !isVideoGroup && (
          <>
            {isAnnounce == true ? (
              <>
                <div className="pb-3 pt-3 w-full px-4 border-bottom-f1">
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => {
                      setSelectedOption(-2, "");
                      setisAnnounceSidebar(!isAnnounceSidebar);
                      setSidebar(isAnnounceSidebar == false && true);
                    }}
                  >
                    <Tab text="Announcements" active={false} />
                    {!isAnnounceSidebar ? (
                      <MdKeyboardArrowRight className="blueColor" size={20} />
                    ) : (
                      <MdKeyboardArrowDown className="blueColor" size={20} />
                    )}
                  </div>
                  <div className="flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2">
                    {isAnnounceSidebar &&
                      announceList?.map((item, index) => (
                        <SideBarNormalDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium`}
                          key={index}
                          onClick={() =>
                            history.push(
                              `/announcement/${item.announcement_id}`,
                              { src: location.pathname, id: groupId }
                            )
                          }
                          title={item.announcement_title}
                        >
                          {item.announcement_title.length > 24
                            ? item.announcement_title.slice(0, 24) + "..."
                            : item.announcement_title}
                        </SideBarNormalDivButtonNew>
                      ))}
                  </div>
                </div>
                <div
                  className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-2 lg:mb-1 pr-2 items-center cursor-pointer border-bottom-f1"
                  onClick={() => {
                    setSelectedOption(-1, "");
                    setSidebar(true);
                    setisAnnounceSidebar(false);
                  }}
                >
                  {selectedOption?.type === -1 ? (
                    <SideBarActiveDivNew className="font-14px font-bold cursor-pointer w-full py-1.5 pl-2">
                      All posts
                    </SideBarActiveDivNew>
                  ) : (
                    <SideBarNormalDivNew className="font-14px font-bold cursor-pointer w-full pl-2 py-1.5">
                      All posts
                    </SideBarNormalDivNew>
                  )}
                </div>
              </>
            ) : (
              <div
                className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-2 lg:mb-1 pr-2 items-center cursor-pointer border-bottom-f1"
                onClick={() => {
                  setSelectedOption(-1, "");
                  setSidebar(true);
                }}
              >
                {selectedOption?.type === -1 ? (
                  <SideBarActiveDivNew className="font-14px font-bold cursor-pointer w-full py-1.5 pl-2">
                    All posts
                  </SideBarActiveDivNew>
                ) : (
                  <SideBarNormalDivNew className="font-14px font-bold cursor-pointer w-full pl-2 py-1.5">
                    All posts
                  </SideBarNormalDivNew>
                )}
              </div>
            )}
            {isAnnounce && (
              <>
                <div
                  className={`border-bottom-f1 ${
                    groupedFilterData.length == 0 ? "pb-2" : ""
                  }`}
                >
                  <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
                    <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                      Topics
                    </div>
                  </div>
                  <div className="w-full px-4">
                    {groupedFilterData.map((items, index) => {
                      const filteredItemsObject = {
                        ...items, // keep all existing properties
                        item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                      };
                      return (
                        <SidebarItemNew
                          isLast={index == groupedFilterData.length - 1}
                          key={index}
                          items={filteredItemsObject}
                          isJournal={isJournal}
                          isShared={isShared}
                          isFeed={isFeed}
                          selectedOption={selectedOption}
                          setSelectedOption={(selectedValue) =>
                            setSelectedOption(0, selectedValue)
                          }
                          valueId={valueId}
                          isAnnounce={isAnnounce}
                        />
                      );
                    })}
                    <div
                      className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                      onClick={() => setShow(false)}
                    >
                      <IoCloseOutline className="w-8 h-8" />
                    </div>
                  </div>
                </div>
                <div
                  className={`border-bottom-f1 ${
                    grouepdValuedata.length == 0 ? "pb-2" : ""
                  }`}
                >
                  <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
                    <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                      Values/Competencies
                    </div>
                  </div>
                  <div className="w-full px-4">
                    {grouepdValuedata.map((items, index) => {
                      const filteredItemsObject = {
                        ...items, // keep all existing properties
                        item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                      };
                      return (
                        <SidebarItemNew
                          key={index}
                          isLast={index == grouepdValuedata.length - 1}
                          items={filteredItemsObject}
                          isJournal={isJournal}
                          isShared={isShared}
                          isFeed={isFeed}
                          selectedOption={selectedOption}
                          setSelectedOption={(selectedValue) =>
                            setSelectedOption(1, selectedValue)
                          }
                          valueId={valueId}
                          isAnnounce={isAnnounce}
                        />
                      );
                    })}
                    <div
                      className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                      onClick={() => setShow(false)}
                    >
                      <IoCloseOutline className="w-8 h-8" />
                    </div>
                  </div>
                </div>
              </>
            )}
            {isFeed && (
              <>
                <div
                  className={`border-bottom-f1 ${
                    groupedFilterData.length == 0 ? "pb-2" : ""
                  }`}
                >
                  <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
                    <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                      Topics
                    </div>
                  </div>
                  <div className="w-full px-4">
                    {groupedFilterData.map((items, index) => {
                      const filteredItemsObject = {
                        ...items, // keep all existing properties
                        item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                      };
                      return (
                        <SidebarItemNew
                          key={index}
                          isLast={index == groupedFilterData.length - 1}
                          items={filteredItemsObject}
                          isJournal={isJournal}
                          isShared={isShared}
                          isFeed={isFeed}
                          selectedOption={selectedOption}
                          setSelectedOption={(selectedValue) =>
                            setSelectedOption(0, selectedValue)
                          }
                          valueId={valueId}
                          isAnnounce={isAnnounce}
                        />
                      );
                    })}
                    <div
                      className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                      onClick={() => setShow(false)}
                    >
                      <IoCloseOutline className="w-8 h-8" />
                    </div>
                  </div>
                </div>
                <div
                  className={`border-bottom-f1 ${
                    grouepdValuedata.length == 0 ? "pb-2" : ""
                  }`}
                >
                  <div className="flex pt-5 pl-3 lg:pt-0 lg:mt-2  cursor-default lg:mb-0 items-center ">
                    <div className="font-14px font-bold cursor pl-1 w-full py-1 lightColor">
                      Values/Competencies
                    </div>
                  </div>
                  <div className="w-full px-4">
                    {grouepdValuedata.map((items, index) => {
                      const filteredItemsObject = {
                        ...items, // keep all existing properties
                        item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                      };
                      return (
                        <SidebarItemNew
                          key={index}
                          isLast={index == grouepdValuedata.length - 1}
                          items={filteredItemsObject}
                          isJournal={isJournal}
                          isShared={isShared}
                          isFeed={isFeed}
                          selectedOption={selectedOption}
                          setSelectedOption={(selectedValue) =>
                            setSelectedOption(1, selectedValue)
                          }
                          valueId={valueId}
                          isAnnounce={isAnnounce}
                        />
                      );
                    })}
                    <div
                      className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                      onClick={() => setShow(false)}
                    >
                      <IoCloseOutline className="w-8 h-8" />
                    </div>
                  </div>
                </div>
              </>
            )}
            {!isFeed && !isAnnounce && (
              <div className="w-full px-4">
                {data.map((items, index) => {
                  const filteredItemsObject = {
                    ...items, // keep all existing properties
                    item: items.item.filter((child) => child.count > 0), // filter only the 'item' array
                  };
                  return (
                    <SidebarItemNew
                      key={index}
                      items={filteredItemsObject}
                      isJournal={isJournal}
                      isShared={isShared}
                      isFeed={isFeed}
                      selectedOption={selectedOption}
                      setSelectedOption={(selectedValue) =>
                        setSelectedOption(index, selectedValue)
                      }
                      valueId={valueId}
                      isAnnounce={isAnnounce}
                    />
                  );
                })}
                <div
                  className="absolute top-5 right-14 lg:hidden text-gray-400 cursor-pointer"
                  onClick={() => setShow(false)}
                >
                  <IoCloseOutline className="w-8 h-8" />
                </div>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default Sidebar;
